import PropTypes from 'prop-types';
import React from 'react';
import { getRoutePath } from '@routes/routes.util';
import Link from 'next/link';
import { withActiveLocale, withActiveLocalePropType } from '../../hocs/withActiveLocale';

/**
 * LocaleLink extends the functionality provided by `next-routes` to better support
 * how we are handling localizations.
 *
 * It will generate links to routes where the locale param automatically pre-populated
 * with the current locale.
 *
 * If i'm looking at the site in `en` setting the route param to `/homepage` would
 * generate a link pointing to `/en/homepage`.
 *
 * See:<br />
 * https://github.com/fridays/next-routes#link-example
 */

function LocaleLink(props) {
  const { route: routeName, activeLocale, params, ...propsPassThrough } = props;
  const routePath = getRoutePath({
    routeName,
    locale: activeLocale.id,
    params
  });

  return <Link href={routePath} {...propsPassThrough} />;
}

LocaleLink.propTypes = {
  /**
   * The currently active locale.
   */
  activeLocale: withActiveLocalePropType,
  /**
   * Route params.
   */
  params: PropTypes.shape({}),
  /**
   * Route name or URL.
   */
  route: PropTypes.string.isRequired
};

LocaleLink.defaultProps = {
  params: {},
  activeLocale: {
    id: 'en',
    label: 'Canada'
  }
};

const WrappedLocaleLink = withActiveLocale(LocaleLink);
export default WrappedLocaleLink;
